import React, { useState, useEffect, useContext, useRef } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";
import { TextInput } from "./input.js";
import { MessageLeft, MessageRight } from "./message";
import { AppContext } from "../../contexts/appContext.js";
import { workAPI } from "../../services/WorkService.js";
import { baseURL } from "../../utils/config";
import Swal from "sweetalert2";
import moment from "moment";

export default function ChatBox({ _id, comment, data }) {
  const token = localStorage.getItem("Token");
  const { user, socket } = useContext(AppContext);

  const useStyles = makeStyles((theme) =>
    createStyles({
      paper: {
        width: "20vw",
        height: "100%",
        maxWidth: "90%",
        maxHeight: "700px",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        [theme.breakpoints.down(1341)]: {
          width: "90%",
        },
      },
      paper2: {
        width: "20vw",
        maxWidth: "20vw",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        [theme.breakpoints.down(1341)]: {
          width: "90%",
        },
      },
      container: {
        height:
          data.user_first == user.username || data.user_second == user.username
            ? "90%"
            : "85%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      messagesBody: {
        width: "calc( 100% - 20px )",
        margin: 10,
        overflowY: "scroll",
        height:
          data.user_first == user.username || data.user_second == user.username
            ? "calc( 100% - 80px )"
            : "100%",
      },
    })
  );

  const classes = useStyles();

  const [message, setMessage] = useState("");
  const scrollToRef = (ref) => {
    ref.current.scrollTo(0, ref.current.scrollHeight);
  };
  const refMessageBox = useRef(null);
  const executeScroll = () => scrollToRef(refMessageBox);
  const updateMessage = () => {
    if (message != "") {
      let message_delete = document.getElementById("message-box-text");
      if (message_delete) {
        message_delete.value = "";
      }
      let fullname = "";
      fullname = user.fullname.split(" ");
      fullname = fullname[0];
      fullname = fullname.replace("นาย", "");
      fullname = fullname.replace("นางสาว", "");
      fullname = fullname.replace("นาง", "");
      socket.emit("SendMessageByID", {
        _id,
        message_obj: {
          text: message,
          time: moment().toString(),
          user: user.username,
          image: null,
          name: fullname,
        },
      });
      socket.emit("SendNotification", {
        _id,
        notification_obj: {
          is_read: false,
          title: "ข้อความใหม่จาก " + data.title + " " + data.type,
          detail: `ข้อความ ${message}`,
          sender: user.username,
          push_to: `/detail-work/${_id}`,
        },
      });
      executeScroll(refMessageBox);
      setMessage("");
    }
  };

  const updateImage = (files) => {
    let form = new FormData();
    form.append("_id", _id);
    form.append("images", files);
    workAPI
      .UploadCommentImage(token, form)
      .then((res) => {
        if (res.status == 200) {
          let fullname = "";
          fullname = user.fullname.split(" ");
          fullname = fullname[0];
          fullname = fullname.replace("นาย", "");
          fullname = fullname.replace("นางสาว", "");
          fullname = fullname.replace("นาง", "");
          socket.emit("SendMessageByID", {
            _id,
            message_obj: {
              text: "",
              time: moment().toString(),
              user: user.username,
              image: res.message,
              name: fullname,
            },
          });
          socket.emit("SendNotification", {
            _id,
            notification_obj: {
              is_read: false,
              title: "ข้อความใหม่จาก " + data.title + " " + data.type,
              detail: `${baseURL}/comment/${res.message}`,
              sender: user.username,
              push_to: `/detail-work/${_id}`,
            },
          });
          executeScroll(refMessageBox);
        } else {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${res.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 3000,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 3000,
        });
      });
  };

  useEffect(() => {
    if (refMessageBox && refMessageBox.current) {
      scrollToRef(refMessageBox);
    }
  }, [comment]);

  return (
    user && (
      <div className={classes.container}>
        <Paper className={classes.paper}>
          <Paper
            id="style-1"
            ref={refMessageBox}
            className={classes.messagesBody}
          >
            {comment.map((res, i) =>
              res.user == user.username ? (
                <MessageRight
                  key={i}
                  message={res.text}
                  timestamp={moment(res.time)
                    .utcOffset("+0700")
                    .format("DD MMM YYYY HH:mm:ss")}
                  displayName={res.name}
                  images={res.image}
                />
              ) : (
                <MessageLeft
                  key={i}
                  message={res.text}
                  timestamp={moment(res.time)
                    .utcOffset("+0700")
                    .format("DD MMM YYYY HH:mm:ss")}
                  displayName={res.name}
                  images={res.image}
                />
              )
            )}
          </Paper>
          <TextInput
            message={message}
            setMessage={setMessage}
            updateMessage={updateMessage}
            updateImage={updateImage}
          />
        </Paper>
      </div>
    )
  );
}
